import FormattedMessage from 'I18n/components/FormattedMessage';
import { isCanvasTheme } from 'foundations-theming/utils';
import { specialtyColor, useTheme as useSpecialtyTheme } from 'foundations-theming-specialty/utils';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { BreezeRegenerateIcon } from 'foundations-assets/icons/components/BreezeRegenerateIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const BreezeRefreshButton = ({
  onRefresh
}) => {
  const theme = useSpecialtyTheme();
  const isCanvas = isCanvasTheme(theme);
  const breezeColor = isCanvas ? 'icon-core-default' : specialtyColor('breeze-icon-field-default');
  return /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "refresh-button",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiAddonCopilotPreview.components.copilotPreview.refreshButton.tooltip"
    }),
    onClick: onRefresh,
    use: "unstyled",
    children: /*#__PURE__*/_jsx(BreezeRegenerateIcon, {
      size: "300",
      color: breezeColor
    })
  });
};
export default BreezeRefreshButton;